"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestLoginToJSONTyped = exports.RequestLoginToJSON = exports.RequestLoginFromJSONTyped = exports.RequestLoginFromJSON = exports.instanceOfRequestLogin = void 0;
/**
 * Check if a given object implements the RequestLogin interface.
 */
function instanceOfRequestLogin(value) {
    return true;
}
exports.instanceOfRequestLogin = instanceOfRequestLogin;
function RequestLoginFromJSON(json) {
    return RequestLoginFromJSONTyped(json, false);
}
exports.RequestLoginFromJSON = RequestLoginFromJSON;
function RequestLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}
exports.RequestLoginFromJSONTyped = RequestLoginFromJSONTyped;
function RequestLoginToJSON(json) {
    return RequestLoginToJSONTyped(json, false);
}
exports.RequestLoginToJSON = RequestLoginToJSON;
function RequestLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'password': value['password'],
    };
}
exports.RequestLoginToJSONTyped = RequestLoginToJSONTyped;
